module.exports = __webpack_public_path__ + "img/logo.ab7899a3.png";